import { module } from 'modujs';
import { Swiper } from 'swiper';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                button: 'changeSlide',
                back: 'goToFirstSlide'
            }
        }
    }

    init() {
        this.slides = Array.from(this.$('slide')).map((item) => {
            return {
                ids: item.dataset.id,
                el: item.outerHTML
            }
        })

        this.currentSlides = []

        this.carousel = new Swiper(this.$('carousel')[0], {
            allowTouchMove: false,
            speed: 600
        })

        this.carousel.on('slideChange', () => {
            if (this.carousel.activeIndex > 0) {
                this.carousel.allowTouchMove = true
            } else {
                this.carousel.allowTouchMove = false
            }
        })

        this.currentSlides = [this.slides[0].el];

        this.carousel.removeAllSlides();
        this.carousel.appendSlide(this.currentSlides)

        this.menuAccordions()

    }

    changeSlide(event) {
        const $btn = event.curTarget;
        const id = $btn.dataset.id

        this.currentSlides = this.slides.map((item) => {
            if (item.ids.includes(id) || item.ids.includes("0")) {
                return item.el
            }
        })

        this.carousel.removeAllSlides();
        this.carousel.appendSlide(this.currentSlides)

        this.carousel.slideTo(1)

        this.menuAccordions()
    }

    goToFirstSlide() {
        this.carousel.slideTo(0)
    }

    menuAccordions() {
        document.querySelectorAll('.c-menu-mobile .js-accordion-menu-item').forEach((item) => {
            item.querySelector('.js-accordion-menu-content').style.height = '0px'
            item.classList.remove('is-active')

            item.querySelectorAll('.js-accordion-menu-header').forEach((item) => {
                item.addEventListener('click', (e) => {
                    const content = item.parentNode.querySelector('.js-accordion-menu-content')
                    if (content.style.height === '0px') {
                        content.style.height = content.scrollHeight + 'px'
                        item.parentNode.classList.add('is-active')
                    } else {
                        content.style.height = '0px'
                        item.parentNode.classList.remove('is-active')
                    }
                    document.querySelectorAll('.c-menu-mobile .js-accordion-menu-content').forEach((item) => {
                        if (item !== content) {
                            item.style.height = '0px'
                            item.parentNode.classList.remove('is-active')
                        }
                    })
                })
            })
        })
    }

    destroy() {
        if (this.carousel && this.carousel.destroy) this.carousel.destroy()
    }
}
